import React from 'react';
import { Drawer, Row, Col, Card, Statistic, Divider, Typography } from 'antd';
import { ShoppingOutlined, TeamOutlined, DollarOutlined, SmileOutlined } from '@ant-design/icons';
import {
  cardStyle,
} from './elements';
import { userTypes } from '../../../types';
import TitleSubtitle from '../../../components/titleSubtitle';

const { Title } = Typography;

interface ViewDetailModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  client: typeof userTypes.client | null;
}

const ViewDetailModal: React.FC<ViewDetailModalProps> = ({ visible, setVisible, client }) => {
  const fiscal = client?.fiscalData;
  console.log({ fiscal })

  const fullNameAddress = [
    fiscal?.address?.street,
    fiscal?.address?.exteriorNumber,
    fiscal?.address?.colony,
    fiscal?.address?.city,
    fiscal?.address?.state,
    fiscal?.address?.country,
    fiscal?.address?.postcode,
  ].filter(Boolean).join(", ");

  const handleCancel = () => {
    setVisible(false);
  };

  const hasFiscalData = !!(
    fiscal?.name ||
  fiscal?.rfc ||
  fiscal?.email ||
  fiscal?.regimenFiscal ||
  fiscal?.usoCFDI ||
  fiscal?.address?.street ||
  fiscal?.address?.exteriorNumber ||
  fiscal?.address?.colony ||
  fiscal?.address?.city ||
  fiscal?.address?.state ||
  fiscal?.address?.country ||
  fiscal?.address?.postcode
  );

  return (
    <>
      <Drawer
        title="Detalle de la Orden"
        visible={visible}
        onClose={handleCancel}
        width={"50%"}
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Órdenes Hoy"
                value={68}
                prefix={<ShoppingOutlined style={{ color: '#e67e22' }} />}
                suffix="🔥"
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Clientes Nuevos"
                value={23}
                prefix={<TeamOutlined style={{ color: '#3498db' }} />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Ingresos Diarios"
                value={1542}
                precision={2}
                prefix={<DollarOutlined style={{ color: '#2ecc71' }} />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ ...cardStyle }}>
              <Statistic
                title="Rating Promedio"
                value={4.8}
                precision={1}
                suffix="/5"
                prefix={<SmileOutlined style={{ color: '#f1c40f' }} />}
              />
            </Card>
          </Col>
        </Row>
        <p>Info de Pago: [Información de pago aquí]</p>
        <p>Fecha Creada: [Fecha creada aquí]</p>
        <p>Preparada: [Fecha preparada aquí]</p>
        <p>Completada: [Fecha completada aquí]</p>

        <Divider />

        {hasFiscalData && (
          <Card
            style={{
              boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
              borderRadius: "15px",
            }}
            title={<Title level={5}>Datos fiscales del cliente</Title>}
          >
            {fiscal ? (
              <Row gutter={[12, 12]}>
                {fiscal?.name && (
                  <Col span={24}><TitleSubtitle title="Nombre" subtitle={fiscal.name} /></Col>
                )}
                {fiscal?.rfc && (
                  <Col span={12}><TitleSubtitle title="RFC" subtitle={fiscal.rfc} /></Col>
                )}
                {fiscal?.email && (
                  <Col span={12}><TitleSubtitle title="Correo electrónico" subtitle={fiscal.email} /></Col>
                )}
                {fiscal?.regimenFiscal && (
                  <Col span={24}><TitleSubtitle title="Régimen Fiscal" subtitle={fiscal.regimenFiscal} /></Col>
                )}
                {fiscal?.usoCFDI && (
                  <Col span={24}><TitleSubtitle title="Uso CFDI" subtitle={fiscal.usoCFDI} /></Col>
                )}
                {fullNameAddress && (
                  <Col span={24}><TitleSubtitle title="Dirección" subtitle={fullNameAddress} /></Col>
                )}
              </Row>
            ) : (
              <Typography.Text type="secondary">No hay datos fiscales disponibles.</Typography.Text>
            )}
          </Card>
        )}

      </Drawer>
    </>
  );
};

export default ViewDetailModal
